var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-btn",
    {
      staticClass: "action-buttons",
      attrs: {
        disabled: _vm.disabled,
        outlined: _vm.outline,
        block: "",
        color: "primary"
      },
      on: {
        click: function($event) {
          return _vm.clicked()
        }
      }
    },
    [
      _c(
        "v-layout",
        {
          attrs: {
            "align-center": "",
            "justify-center": "",
            row: "",
            "fill-height": "",
            wrap: ""
          }
        },
        [
          _c(
            "v-flex",
            { staticClass: "text-xs-right" },
            [
              _c("v-avatar", { attrs: { tile: "", size: "32px" } }, [
                _c("img", { attrs: { src: _vm.imageSrc } })
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("v-flex", { staticClass: "text-xs-left" }, [
            _c("span", { staticClass: "title-form" }, [
              _vm._v(_vm._s(_vm.title))
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-444a9b46", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-444a9b46","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Orders/Show/DetailButton.vue
// module id = null
// module chunks = 